<template>
  <u-popover
    v-model:visible="visible"
    placement="right-start"
    dropdown-class="create-agent-dropdown"
    trigger="click"
  >
    <template #content>
      <div>
        <div class="pl-3 tip text-[14px] text-text-neutral-tertiary">
          {{
            $t(
              'views.layout.components.CreateAgent.ccec8026bff82722510ea39783c0824b'
            )
          }}
        </div>
        <ul class="flex flex-col gap-[6px] mt-[4px]">
          <li
            class="px-3 py-[10px] gap-[8px] create-agent flex items-center"
            @click="handleCreateAgent('selfPlannedAgent')"
          >
            <div class="h-[40px] w-[40px] fc rounded-[8px] selfPlannedAgent">
              <img
                src="@/assetsCommon/layout/selfPlannedAgent.svg"
                alt=""
                width="36"
              />
            </div>
            <div>
              <div class="agent-title text-text-neutral-base font-bold">
                {{
                  $t(
                    'views.layout.components.CreateAgent.c063f26ac14290233a057cf662fc54b6'
                  )
                }}
              </div>
              <div
                class="text-[12px] leading-[20px] text-text-neutral-tertiary"
              >
                {{
                  $t(
                    'views.layout.components.CreateAgent.ccba1be1e4854a82d1e047630609d09c'
                  )
                }}
              </div>
            </div>
          </li>

          <li
            class="px-3 py-[10px] gap-[8px] create-agent flex items-center"
            @click="handleCreateAgent('multiAgent')"
          >
            <div class="h-[40px] w-[40px] fc rounded-[8px] multiAgent">
              <img width="36" :src="multiAgentIcon" alt="" />
            </div>
            <div>
              <div class="agent-title text-text-neutral-base font-bold">
                Multi-Agent
              </div>
              <div class="text-[12px] agent-desc text-text-neutral-tertiary">
                {{
                  $t(
                    'views.layout.components.CreateAgent.928b91cfbb7bdefdc89d22fff7bf5421'
                  )
                }}
              </div>
            </div>
          </li>

          <li
            class="px-3 py-[10px] gap-[8px] create-agent flex items-center"
            @click="handleCreateAgent('aiAgent')"
          >
            <div class="h-[40px] w-[40px] fc rounded-[8px] penAgent">
              <img
                src="@/assetsCommon/layout/writeAgent.svg"
                alt=""
                width="36"
              />
            </div>
            <div>
              <div class="agent-title text-text-neutral-base font-bold">
                {{
                  $t(
                    'views.layout.components.CreateAgent.4135857f56bf02c8ab723ce05136e048'
                  )
                }}
              </div>
              <div
                class="text-[12px] leading-[20px] text-text-neutral-tertiary"
              >
                {{
                  $t(
                    'views.layout.components.CreateAgent.be6e9c8cf6ad1afd994c490ac5ebdab9'
                  )
                }}
              </div>
            </div>
          </li>

          <li
            v-if="isInVoiceAgentWhiteList"
            class="px-3 py-[10px] gap-[8px] create-agent flex items-center"
            @click="handleCreateAgent('voiceAgent')"
          >
            <div class="h-[40px] w-[40px] fc rounded-[8px] voiceAgent">
              <img
                src="@/assetsCommon/layout/voiceAgent.svg"
                alt=""
                width="36"
              />
            </div>
            <div>
              <div class="agent-title text-text-neutral-base font-bold">
                {{
                  $t(
                    'views.layout.components.CreateAgent.c390a7eb09951d7f450e1808175cb505'
                  )
                }}
              </div>
              <div
                class="text-[12px] leading-[20px] text-text-neutral-tertiary"
              >
                {{
                  $t(
                    'views.layout.components.CreateAgent.8c1294cefcf6d7bfe64867d9d3eda9fb'
                  )
                }}
              </div>
            </div>
          </li>

          <li
            class="px-3 py-[10px] gap-[8px] create-agent flex items-center"
            @click="handleCreateAgent('taskFlowAgent')"
          >
            <div class="h-[40px] w-[40px] fc rounded-[8px] taskFlowAgent">
              <img width="36" src="@/assetsCommon/flow/taskflow.svg" alt="" />
            </div>
            <div>
              <div class="agent-title text-text-neutral-base font-bold">
                {{
                  $t(
                    'views.layout.components.CreateAgent.d49c0d39b9c04c92cce16224704807ad'
                  )
                }}
              </div>
              <div class="text-[12px] agent-desc text-text-neutral-tertiary">
                {{
                  $t(
                    'views.layout.components.CreateAgent.4ff67c6056b0ef708c81ff7c93576e6d'
                  )
                }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <u-button
      v-if="!isMin"
      type="primary"
      class="w-[216px]"
      :class="classNames"
      :size="size"
      tabindex="0"
    >
      <BotIcon :padding="2" name="plus" size="12" />
      <span v-if="!isMin" class="ml-[4px] font-semibold text-sm">
        {{ buttonText }}
      </span>
    </u-button>
    <u-button
      v-if="isMin"
      type="primary"
      class="w-[40px] rounded-[8px]"
      tabindex="0"
      size="large"
    >
      <BotIcon :padding="3" name="plus" size="16" />
    </u-button>
  </u-popover>

  <TemplateInfo ref="templateInfoRef" parent-dom="#app" />
  <AddAgent ref="addAgentRef" />
  <AddVoiceAgent ref="addVoiceAgentRef" />
</template>
<script>
import i18n from '@/locales/i18n';
import { defineComponent, getCurrentInstance, ref } from 'vue';
// import { useRouter } from 'vue-router';
import { getTemplateDefaultApi } from '@/api/aiwrite';
import { isInWhiteListApi } from '@/api/voiceAgent';
import TemplateInfo from '@/views/aiWrite/template/components/TemplateInfoDiaglog.vue';
import AddAgent from '@/views/botSetting/components/AddAgent.vue';
import AddVoiceAgent from '@/views/voiceAgent/setting/components/AddVoiceAgent.vue';
import multiAgentIcon from '@/assetsCommon/multiAgent/multiAgent.png';

const { t } = i18n.global;

export default defineComponent({
  components: {
    TemplateInfo,
    AddAgent,
    AddVoiceAgent
  },
  props: {
    isMin: {
      type: Boolean,
      default: false
    },
    style: {
      type: [Object, String],
      default: () => ({
        height: '40px'
      })
    },
    size: {
      type: String,
      default: 'large'
    },
    classNames: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: t(
        'views.layout.components.CreateAgent.ccec8026bff82722510ea39783c0824b'
      )
    }
  },
  emits: ['ai-write'],
  setup(props, { emit }) {
    // const router = useRouter();
    const instance = getCurrentInstance();
    const arr = [1, 2, 3, 4];
    const templateInfoRef = ref(null);
    const addAgentRef = ref(null);
    const addVoiceAgentRef = ref(null);
    const templateDefault = ref({
      llm_model: '',
      llm_model_name: '',
      divergence: 0,
      top_p: 0,
      max_tokens: 0
    });
    const visible = ref(false);
    const getTemplateDefault = async () => {
      const res = await getTemplateDefaultApi();
      templateDefault.value = res;
    };
    getTemplateDefault();

    const isInVoiceAgentWhiteList = ref(false);
    const checkIsInVoiceAgentWhiteList = async () => {
      const res = await isInWhiteListApi();
      isInVoiceAgentWhiteList.value = res;
    };
    if (IS_DOMESTIC) {
      checkIsInVoiceAgentWhiteList();
    }

    const handleCreateAgent = type => {
      visible.value = false;
      switch (type) {
        case 'selfPlannedAgent':
          addAgentRef.value.show('add');
          break;
        case 'chatFlowAgent':
          break;
        case 'multiAgent':
          addAgentRef.value.show('multi');
          break;
        case 'taskFlowAgent':
          addAgentRef.value.show('taskFlow');
          break;
        case 'aiAgent': {
          const hasExternalListener = instance?.vnode?.props?.onAiWrite;
          if (hasExternalListener) {
            emit('ai-write');
          } else {
            templateInfoRef.value.show({
              type: 'add',
              data: {
                ...templateDefault.value
              }
            });
          }
          break;
        }
        case 'voiceAgent':
          addVoiceAgentRef.value.show();
          break;
        default:
          break;
      }
    };
    return {
      arr,
      handleCreateAgent,
      templateInfoRef,
      addAgentRef,
      addVoiceAgentRef,
      multiAgentIcon,
      visible,
      isInVoiceAgentWhiteList
    };
  }
});
</script>
<style scoped lang="less">
.create-agent {
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: var(--background-control-bg-control-item-hover);
  }
  .agent-title {
    line-height: 22px;
    margin-bottom: 2px;
  }
}
</style>
<style lang="less">
.create-agent-dropdown.uui-popover-inner {
  border-radius: 8px !important;
}
.create-agent-dropdown .uui-popover-inner {
  border-radius: 8px !important;
  border: none !important;
}
.create-agent-dropdown
  .uui-popover-inner-content.create-agent-dropdown-content {
  padding: 16px 12px !important;
}
</style>
